export default __webpack_public_path__ + "dist/media/Pencil.5e2b5809.svg";